<template>
  <div class="subsector croplands">
    <div class="parent-sector">
      <p>Agriculture</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Croplands</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                A number of land management activities add nitrogen to soils,
                thus increasing the amount of N₂O emitted, including various
                cropping practices and livestock waste management. Indirect
                additions of nitrogen occur through volatilization and
                atmospheric deposition of ammonia and oxides of nitrogen that
                originate from (1) the application of fertilizers and livestock
                wastes onto agricultural land and (2) surface runoff and
                leaching of nitrogen from these same sources.
              </p>
              <p>
                From 2015 through 2030, N₂O emissions from agricultural soils
                are projected to increase by 14%. Over the projection period,
                emissions are expected to increase in all regions. The primary
                factor for the increase in emissions from 2015 through 2030 is
                increased synthetic fertilizer consumption to meet growing
                agricultural demand in Africa, the Middle East, Central and
                South America, and non-OECD Asia.
              </p>
              <p>
                Globally, croplands are responsible for 2,206 MtCO₂e of
                emissions in 2030. Of these emissions, technology is available
                to mitigate 3%, or 74 MtCO₂e. In 2030, 61% of potential
                mitigation is available at break-even prices below $0/tCO₂e.
                Additional reductions are possible with the inclusion of more
                costly abatement measures. For example, mitigation potential
                increases to 53 MtCO₂e by including abatement measures with an
                implementation cost less than or equal to $50/tCO₂e.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartCroplands1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartCroplands2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCroplands1 from "@/components/agriculture/ChartCroplands1";
import ChartCroplands2 from "@/components/agriculture/ChartCroplands2";

export default {
  components: {
    ChartCroplands1,
    ChartCroplands2
  },
  data() {
    return {
      currentComp: "ChartCroplands1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-green-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #28530a;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}
.center button {
  position: static !important;
}
</style>
